<template>
    <div>
        <Dialog v-bind:value="value" @input="$emit('input', $event)"
                title="Neue Seite anlegen"
                :ok-disabled="!validate"
                :loading="loading"
                @click:outside="close"
                @ok="submit"
                @cancel="close"
        >
            <form>
                <div class="mx-2 mb-3 d-flex align-baseline">
                    <div class="text-body-1 pr-4">Umgebung:</div>
                    <div class="ml-4 d-flex" style="position: relative; top:4px;">
                        <v-checkbox v-model="isDisplay" label="Display" class="mt-0" :color="ada.blue"
                                    :class="{'mr-14': envErrors.length === 0}"
                                    :true-value="1" :false-value="0" hide-details="auto"
                                    @change="$v.env.$touch()" :error-messages="envErrors"></v-checkbox>
                        <v-checkbox v-model="isVideo" label="Video" :color="ada.blue" :error-messages="envErrors"
                                    :true-value="1" :false-value="0" class="mt-0 isVideoCbx" hide-details="auto"
                                    @change="$v.env.$touch()"></v-checkbox>
                    </div>
                </div>
                <div class="mx-2">
                    <Input v-model="name" label="Seiten - Bezeichnung"
                           :error-messages="nameErrors"
                           :required="true"
                           @input="$v.name.$touch()"
                           @blur="$v.name.$touch()"></Input>
                    <Dropdown v-model="selected_publisher" label="Publisher" :items="publisher"
                              :error-messages="publisherErrors"
                              item-text="Name"
                              item-value="Name"
                              @input="$v.selected_publisher.$touch()"
                              @blur="$v.selected_publisher.$touch()"></Dropdown>
                </div>
                <v-slide-y-transition hide-on-leave>
                    <div v-if="isDisplay === 1">
                        <v-divider class="mt-4 mb-8"></v-divider>
                        <span class="text-body-1">Ersten Sitetype definieren</span>
                        <div class="mx-2">
                            <v-text-field v-model="sitetype_name" label="Sitetype - Bezeichnung"
                                          :error-messages="sitetypeErrors"
                                          required
                                          :color="ada.blue"
                                          :readonly="false"
                                          @input="$v.sitetype_name.$touch()"
                                          @blur="$v.sitetype_name.$touch()"
                            ></v-text-field>
                            <v-text-field v-model="hash" label="Hash"
                                          required
                                          :error-messages="hashErrors"
                                          @input="$v.hash.$touch()"
                                          @blur="$v.hash.$touch()"
                            ></v-text-field>
                            <Dropdown v-model="selected_type" :items="device_types" label="Device Type"
                                      :error-messages="typeErrors"
                                      @input="$v.selected_type.$touch()"
                                      @blur="$v.selected_type.$touch()"
                            ></Dropdown>
                        </div>
                    </div>
                </v-slide-y-transition>
            </form>
        </Dialog>
        <Snackbar v-model="successSnackbar" color="success">Seite erfolgreich angelegt.</Snackbar>
    </div>
</template>

<script>
import Dropdown from "../../../components/Inputs/Dropdown";
import ada from "../../../scss/ada_colors.scss"
import {validationMixin} from 'vuelidate'
import {required, requiredIf} from 'vuelidate/lib/validators'
import Input from "../../../components/Inputs/Input";
import Utils from "../../../scripts/Utils";
import Snackbar from "../../../components/Snackbar";
import Dialog from "../../../components/Dialog";

function mustBeTrue() {
    return this.isVideo === 1 || this.isDisplay === 1
}

export default {
    name: "AddSiteDialog",
    props: ['value'],
    mixins: [validationMixin],
    validations() {
        return {
            name: {required},
            selected_publisher: {required},
            hash: {requiredIf: requiredIf(() => this.isDisplay === 1)},
            sitetype_name: {requiredIf: requiredIf(() => this.isDisplay === 1)},
            selected_type: {requiredIf: requiredIf(() => this.isDisplay === 1)},
            env: {mustBeTrue}
        }
    },
    components: {Dialog, Snackbar, Input, Dropdown},
    data: () => {
        return {
            name: null,
            sitetype_name: null,
            hash: null,
            selected_publisher: null,
            selected_type: null,
            device_types: [
                {text: 'App', value: 'app'},
                {text: 'Mobile', value: 'mobile'},
                {text: 'Desktop', value: 'desktop'}
            ],
            isVideo: 0,
            isDisplay: 0,
            env: null,
            successSnackbar: false,
            loading: false,
            ada
        }
    },
    computed: {
        vuexState() {
            return this.$store.state.display;
        },
        siteDetails() {
            return this.vuexState.siteDetails;
        },
        publisher() {
            return this.vuexState.publisher || [];
        },
        nameErrors() {
            return Utils.handleError(this, 'name', 'Name ist erforderlich.');
        },
        publisherErrors() {
            return Utils.handleError(this, 'selected_publisher', 'Publisher ist erforderlich.');
        },
        sitetypeErrors() {
            return Utils.handleError(this, 'sitetype_name', {requiredIf: 'Sitetype ist erforderlich.'});
        },
        hashErrors() {
            return Utils.handleError(this, 'hash', {requiredIf: 'Hash ist erforderlich.'});
        },
        typeErrors() {
            return Utils.handleError(this, 'selected_type', {requiredIf: 'Device Type ist erforderlich.'});
        },
        envErrors() {
            return Utils.handleError(this, 'env', {mustBeTrue: 'Umgebung ist erforderlich.'});
        },
        validate() {
            return this.nameErrors.length === 0 &&
                this.publisherErrors.length === 0 &&
                this.sitetypeErrors.length === 0 &&
                this.hashErrors.length === 0 &&
                this.typeErrors.length === 0 &&
                this.envErrors.length === 0;
        }
    },
    methods: {
        async submit() {
            this.$v.$touch();
            if (this.validate) {
                this.loading = true;
                let data = await this.$store.dispatch('settings/createSite', this.getBody());
                this.loading = false;
                if (data.Status) {
                    this.successSnackbar = true;
                    this.close();
                } else {
                    this.$root.$emit('snackbar', 'Error: Fehler beim Speichern', 'error');
                }
            }
        },
        getBody() {
            let ret = {
                publisher_id: this.selected_publisher.PublisherId,
                name: this.name,
                isVideo: this.isVideo,
                isDisplay: this.isDisplay
            }
            if (this.isDisplay) {
                ret.Name = this.sitetype_name;
                ret.Hash = this.hash;
                ret.Type = this.selected_type.value;
            }
            return ret; /*{
                Name: this.sitetype_name,
                Hash: this.hash,
                Type: this.selected_type.value
            }*/
        },
        reset() {
            this.name = null;
            this.sitetype_name = null;
            this.hash = null;
            this.selected_publisher = null;
            this.selected_type = null;
            this.env = null;
            this.isDisplay = 0;
            this.isVideo = 0;
            this.$v.$reset();
        },
        close() {
            this.$store.commit('settings/resetSelected');
            this.reset();
            this.$emit('input', false); // set v-model to false -> close dialog
        },
    },
    watch: {
        isVideo(newValue) {
            this.env = (newValue === 1 || this.isDisplay === 1);
        },
        isDisplay(newValue) {
            this.env = (newValue === 1 || this.isVideo === 1);
        },
    },

}
</script>

<style lang="scss" scoped>
::v-deep .isVideoCbx .v-messages__message {
    display: none !important;
}
</style>